import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {Message} from "../../../../../../core/class/message";
import {ToastrService} from "ngx-toastr";
import {DocumentService} from "../../../../../../core/services/document.service";
import {NotificationService} from "../../../../../../core/services/notification.service";
import {WarningComponent} from "../../../../../../shared/components/warning/warning.component";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-decline-sign-document',
  templateUrl: './decline-sign-document.component.html',
  styleUrls: ['./decline-sign-document.component.scss']
})
export class DeclineSignDocumentComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private message: Message,
    private toastr: ToastrService,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<DeclineSignDocumentComponent>,
    public notificationService: NotificationService,
  ) {
    this.document = data.document;

  }

  document = {
    id: 0,
    reason: ''
  };
  formChangesSubscription: Subscription;

  @ViewChild('f', {static: false}) ngForm: NgForm;
  public isFormChanging: boolean;
  private success: boolean;

  ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });

    // Focus on textarea reason after load
    // There's a problem if not setTimeout it will focus on 'reason' then lost focus right after
    setTimeout(_ => document.getElementById('reason').focus(), 500);
  }

  ngOnInit() {
    this.notificationService.subscribeErrorService();

  }

  cancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  declineSignDocument() {
    this.documentService.declineSignDocument(this.document).subscribe(rs => {
      if(!rs.success){
        this.toastr.error(rs.message);
        return
      }
      this.success = true;
      this.toastr.success(this.message.getMessage('messages.refuse_sign_success'));
      this.dialogRef.close(this.success);
    });
  }
}
